import contentfulGql from 'js/lib/contentfulGql';

import { entWebsiteBlockAssemblyFragment } from 'bundles/ent-website/queries/EntWebsiteBlockAssembly';
import { ctaFragment } from 'bundles/ent-website/queries/common';

export const entWebsiteTabsFragment = contentfulGql`#graphql
  ${ctaFragment}
  fragment EntWebsiteTabs on EntWebsiteTabs {
    slug
    primaryButtons {
      ctasCollection {
        items {
          ...Cta
        }
      }
    }
    activeTabIndex
    secondaryButtons {
      ctasCollection {
        items {
          ...Cta
        }
      }
    }
  }
`;

export const entWebsiteBlockTabsQuery = contentfulGql`#graphql
  ${entWebsiteBlockAssemblyFragment}
  ${entWebsiteTabsFragment}
  query entWebsiteBlockTabs($id: String!, $preview: Boolean, $locale: String!) {
    entWebsiteBlockAssembly(id: $id, preview: $preview, locale: $locale) {
      ...EntWebsiteBlockAssembly
      reference {
        __typename
        ...EntWebsiteTabs
      }
    }
  }
`;
